import MainFrame from "../../components/mainFrame";
import { Box, Button } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DownloadIcon from "@mui/icons-material/Download";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import { Helmet } from "react-helmet";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Reviews() {
  const { setShow, setContent } = useModal();
  function handleOpenModal(type: string) {
    // if (type === "edit") {
    //     setContent({
    //         title: " ویرایش نظر ",
    //         body: <AddModal />
    //     })
    // }
    // if (type === "add") {
    //     setContent({
    //         title: " افزودن نظر ",
    //         body: <AddModal />
    //     })
    // }
    if (type === "delete") {
      setContent({
        title: "حذف نظر ",
        body: <DeleteModal handleDelete={() => console.log("delete")} />,
      });
    }
    if (type === "export") {
      setContent({
        title: "گرفتن خروجی از نظرات",
        body: <>export</>,
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> نظرات | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="نظرات">
        <Button
          onClick={() => handleOpenModal("export")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <DownloadIcon />
          خروجی
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "درباره" },
          { name: "نویسنده" },
          { name: "رتبه بندی" },
          { name: "توضیحات" },
        ]}
        length={0}
        // rows={[{}, {}]}
        // operations={true}
      >
        <Cell></Cell>
        <Cell></Cell>
        <Cell></Cell>
        <Cell></Cell>
        {/* <Cell
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <IconButton onClick={() => handleOpenModal("edit")}>
                        <EditIcon sx={{ color: 'divider' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenModal("delete")}>
                        <DeleteIcon sx={{ color: 'divider' }} />
                    </IconButton>
                </Cell> */}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Reviews);
